// URL for a file in public/ (e.g. "assets/foundation.png"). On the VSGA website the app runs on a
// vsga.org page, so relative paths would point at vsga.org; embed.js records where the app is hosted.
export function appAsset(path: string): string {
  const base = (window as any).__VSGA_VIP_BASE__ ?? process.env.PUBLIC_URL ?? "";
  return `${base}/${path.replace(/^\/+/, "")}`;
}
